<template>
    <main class="category_wrapper wishlist_wrapper">
      <!-- Page Header -->
      <div class="page-head">
        <div class="container">
          <router-link to="/">
            {{ lang == 'en' ? 'Home' : 'الرئيسية' }}
          </router-link>
          <i :class="lang == 'en' ? 'fa-solid fa-chevron-right' : 'fa-solid fa-chevron-left'"></i>
          {{ lang == 'en' ? 'Build PC' : 'جمع حاسوبك' }}
        </div>
      </div>
  
      <!-- Products Section -->
      <div class="container" style="margin: 0 auto !important">
        <div class="container products" >
          <!-- Heading & Filters -->
          <div class="head">
            <h2>{{ lang == 'en' ? 'Build Your Computer' : 'جمع الكمبيوتر الخاص بك' }}</h2>
            <div class="sort">
              <div>
                <select v-model="per_page" @change="page = 1; fetchProducts(selectedCategoryId)">
                  <option value="20">{{ lang == 'en' ? 'Show 20 items' : 'عرض 20 عنصر' }}</option>
                  <option value="40">{{ lang == 'en' ? 'Show 40 items' : 'عرض 40 عنصر' }}</option>
                  <option value="60">{{ lang == 'en' ? 'Show 60 items' : 'عرض 60 عنصر' }}</option>
                </select>
              </div>
              <div>
                {{ lang == 'en' ? 'Sort By:' : 'ترتيب حسب:' }}
                <select v-model="sort_by_price" @change="fetchProducts(selectedCategoryId)">
                  <!-- <option value="">{{ lang == 'en' ? 'Select Sorting' : 'اختر الترتيب' }}</option> -->
                  <option value="asc_price">{{ lang == 'en' ? 'Price Low To High' : 'السعر من الارخص للاعلى' }}</option>
                  <option value="desc_price">{{ lang == 'en' ? 'Price High To Low' : 'السعر من الاعلى للارخص' }}</option>
                </select>
              </div>
            </div>
          </div>
          <hr>
  
          <!-- Main Build Section -->
          <div class="build_wrapper">
            <!-- Categories Sidebar -->
            <div class="table_wrapper cartgories" v-if="categories && categories.length > 0">
              <table>
                <thead>
                  <tr>
                    <th>{{ lang == 'en' ? 'Components' : 'المكونات' }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="category in categories" :key="category.id">
                    <td :class="{ selected: selectedCategoryId === category.id }"
                        @click="selectedCategoryId = category.id; fetchProducts(selectedCategoryId)">
                      <div class="category-content">
                        <span>{{ category.name }}</span>
                        <span v-if="selectedItems[category.id]">
                          <i class="fa-solid fa-check"></i>
                        </span>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
              <button @click="addItemsToCart" style="padding: 15px 5px; margin-top: 10px;width: 100%">
                <i class="fa-solid fa-cart-plus"></i>
                {{ lang == 'ar' ? "اضافة العناصر المختارة الي العربة" : "Add Selected items to Cart" }}
              </button>
            </div>
  
            <!-- Product List -->
            <div class="body" v-if="products && products.length > 0">
              <div class="product" v-for="item in products" :key="item.id">
                <img v-if="item.shipping_abroad" src="./../assets/imgs/shipping_abroad.png" alt="shipping abroad" class="shipping_icon">
                <div class="a_rep">
                  <div class="head">
                    <div class="left">
                      <div class="img">
                        <img :src="item.main_image" :alt="item.name">
                      </div>
                      <button
                        :class="selectedItems[selectedCategoryId]?.id === item.id ? 'selected' : ''"
                        :disabled="!isProductInStock(item)" @click="toggleSelection(item)">
                        <i v-if="selectedItems[selectedCategoryId]?.id === item.id" class="fa-regular fa-circle-check"></i>
                        {{ item.type === 0 ? selectedItems[selectedCategoryId]?.id === item.id ? (lang == 'en' ? "Selected" : "مختار" ) :
                          (lang == 'en' ? "Select" : "اختر" ) :
                          (isProductInStock(item) ?  selectedItems[selectedCategoryId]?.id === item.id ? (lang == 'en' ? "Selected" : "مختار") :
                          (lang == 'en' ? "Select" : "اختر" ) :
                          (lang == 'en' ? "Out Of Stock" : "نفذت الكمية")) }}
                           <!-- (lang == 'ar' ? "إنتهى من المخزن" : "Out of Stock")  -->
                      </button>
                    </div>
                    <div class="text">
                      <div class="prod-name">
                        <a :href="`/product/${item.id}/${replaceSpaces(item.name)}`" target="_blank">
                          {{ item.name }}
                        </a>
                      </div>
                      <div class="prod-name desc">
                        <div v-html="item.desc.length > 200 ? item.desc.slice(0, 200) + '...' : item.desc"></div>
                        <span class="hint-pop-up" v-if="item.desc.length > 200" v-html="item.desc"></span>
                      </div>
                      <div class="responsive-container">
                        <div class="rate">
                          <div class="stars">
                            <i v-for="(star, index) in getStars(item.reviews_avg_rating)" :key="index" :class="star"></i>
                          </div>
                          ({{ item.reviews_count }} {{ lang == 'en' ? "Reviews" : "مراجعات" }})
                        </div>
                        <div class="price-stock">
                          <div class="price">
                            <h1 v-if="item.price_after_discount">
                              {{ item.price_after_discount.toLocaleString() }} {{ lang == 'en' ? 'EGP' : 'جنيه مصري' }}
                            </h1>
                            <h1>{{ item.price.toLocaleString() }} {{ lang == 'en' ? 'EGP' : 'جنيه مصري' }}</h1>
                          </div>
                          <p class="stock"
                            :class="item.type == 0 ? 'in' : (isProductInStock(item) ? 'managed' : 'out')">
                            {{ item.type == 0 ? (lang == 'en' ? "In Stock" : "متاح") :
                              (isProductInStock(item) ? (lang == 'en' ? "Limited Stock" : "كمية محدودة") :
                              (lang == 'en' ? "Out Of Stock" : "نفذت الكمية")) }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
  
              <!-- Pagination -->
              <div class="pagination" v-if="last_page > 1">
                <div v-for="page_num in last_page" :key="page_num">
                  <label :for="`page_num_${page_num}`" :class="page_num == page ? 'active' : ''">{{ page_num }}</label>
                  <input type="radio" name="page_num" :id="`page_num_${page_num}`" v-model="page" :value="page_num" @change="fetchProducts(selectedCategoryId)">
                </div>
              </div>
            </div>

            <div class="container not_products" v-else>
            <h1 style="margin: 5rem 0; text-align:center;color: #717171;" >{{ lang == 'en' ? "This Category does not contain any product yet!" : "هذه الفئة لا تحتوي على أي منتج حتى الآن!" }}</h1>
            </div>

          </div>
        </div>
      </div>
  
      <!-- Right Side Drawer -->
      <div class="side-drawer" :class="{ open: showDrawer }">
        <div class="drawer-content" v-if="categories && categories.length > 0">
          <h3>{{ lang == 'en' ? 'Selected Components' : 'العناصر المختارة' }}</h3>
          <div v-if="Object.keys(selectedItems).length < 1" class="empty-msg">
            {{ lang === 'en' ? 'No components selected' : 'لا توجد مكونات مختارة' }}
          </div>
          <div v-for="category in categories" :key="category.id">
            <h5 v-if="selectedItems[category.id]" class="selected-component">{{ category.name }}</h5>
            <div v-if="selectedItems[category.id]" class="listtile">
              <div class="productImage">
                <img :src="selectedItems[category.id].main_image" :alt="selectedItems[category.id].name">
              </div>
              <div class="titleAndQuantity">
                <p v-html="selectedItems[category.id].name.length > 35 ? selectedItems[category.id].name.slice(0, 35) + '...' : selectedItems[category.id].name"></p>
                <div class="quantity">
                  <span @click="decreaseQuantity(category.id)" class="qtyBtn" :style="{ cursor: selectedItems[category.id]?.quantity === 1 ? 'not-allowed' : 'pointer' }">-</span>
                  <span>{{ selectedItems[category.id].quantity }}</span>
                  <span @click="increaseQuantity(category.id)" class="qtyBtn">+</span>
                </div>
              </div>
              <i class="fa-solid fa-trash" @click="removeSelectedItem(category.id)"></i>
            </div>
            <hr v-if="selectedItems[category.id]">
          </div>
          <div style="height: 40px;"></div>
        </div>
  
        <!-- Drawer Toggle -->
        <div class="drawer-toggle-icon" @click="showDrawer = !showDrawer" :style="{ right: showDrawer ? '350px' : '0' }">
          <i :class="showDrawer ? 'fa-solid fa-arrow-right' : 'fa-solid fa-arrow-left'"></i>
        </div>
      </div>
    </main>
  </template>
  

<script>
const API_URL = process.env.VUE_APP_API_URL
global.jQuery = require('jquery');
var $ = global.jQuery;
window.$ = $;

import axios from 'axios';

export default {
    name: 'BuildPcView',
    data() {
        return {
            categories: null,
            selectedCategoryId: null,
            products: null,
            per_page: 20,
            page: 1,
            total: 0,
            last_page: 0,
            sort_by_price: 'asc_price',
            lang: 'en',
            selectedItems: [],
            allAdded: true,
            isuser: true,
            showDrawer: false,
            // quantity: 1,
        }
    },
    methods: {
        async getCategories() {
            $('.loader').fadeIn().css('display', 'flex')
            try {
                const response = await axios.get(`${API_URL}/categories/children/children?category_id=34`,
                    {
                        headers: {
                            "lang": this.lang
                        },
                    }
                );
                if (response.data.status === true) {
                    $('.loader').fadeOut()
                    this.categories = response.data.data;
                    this.selectedCategoryId = this.categories[0].id
                } else {
                    $('.loader').fadeOut()
                    document.getElementById('errors').innerHTML = ''
                    $.each(response.data.errors, function (key, value) {
                        let error = document.createElement('div')
                        error.classList = 'error'
                        error.innerHTML = value
                        document.getElementById('errors').append(error)
                    });
                    $('#errors').fadeIn('slow')

                    setTimeout(() => {
                        $('input').css('outline', 'none')
                        $('#errors').fadeOut('slow')
                    }, 3500);
                }

            } catch (error) {
                document.getElementById('errors').innerHTML = ''
                let err = document.createElement('div')
                err.classList = 'error'
                err.innerHTML = 'server error try again later'
                document.getElementById('errors').append(err)
                $('#errors').fadeIn('slow')
                $('.loader').fadeOut()

                setTimeout(() => {
                    $('#errors').fadeOut('slow')
                }, 3500);

                console.error(error);
            }
        },
        async addItemsToCart() {
            let token = sessionStorage.getItem('user_token');
            $('.loader').fadeIn();
            document.getElementById('errors').innerHTML = ''; // Clear previous errors
            if (!token) {
                let cart = JSON.parse(sessionStorage.getItem('cartItems')) || [];
                let itemsToBeAdded = JSON.parse(sessionStorage.getItem('selectedItems')) || {};
        
                for (const categoryId in itemsToBeAdded) {
                    const selectedItem = itemsToBeAdded[categoryId];
                    // console.log("selectedItemmmmm", selectedItem)
                    
                    if (selectedItem) {
                        console.log("selectedItemmmmm", selectedItem)
                        // const itemType = typeof selectedItem.type === 'string' ? selectedItem.type : String(selectedItem.type);
                        let itemToBeAdded = {
                            product: selectedItem,
                            qty: selectedItem.quantity,
                            type: "product"
                        };
                        console.log(itemToBeAdded);
                        // Check if the item already exists in the cart
                        const existingItemIndex = cart.findIndex(item => item.product.id === selectedItem.id);
        
                        if (existingItemIndex > -1) {
                            cart[existingItemIndex].qty += selectedItem.quantity;
                        } else {
                            cart.push(itemToBeAdded);
                        }
                    }
                }
                sessionStorage.setItem('cartItems', JSON.stringify(cart));
                sessionStorage.removeItem('selectedItems'); // Clear selected items after adding to local cart
    
                let successMessage = document.createElement('div');
                successMessage.classList = 'success';
                successMessage.innerHTML = this.lang === "ar" ? "تمت الإضافة إلى السلة" : "Added to cart";
                document.getElementById('errors').append(successMessage);
                $('#errors').fadeIn('slow');
                setTimeout(() => {
                    $('#errors').fadeOut('slow');
                    $('.loader').fadeOut();
                    window.location.href = '/my-cart';
                }, 1500);
                return;
            } else if (token) {
                try {
                    // let cartItems = JSON.parse(sessionStorage.getItem('cartItems')) || [];
                    let selectedItems = JSON.parse(sessionStorage.getItem('selectedItems')) || {};
                    let itemsToSend = [];
        
                    // Add items from selectedItems to the itemsToSend array
                    for (const categoryId in selectedItems) {
                        const selectedItem = selectedItems[categoryId];
                        // console.log("selectedItem two", selectedItem)
                        if(selectedItem && selectedItem !== null) {
                            // const itemType = typeof selectedItem.type === 'string' ? selectedItem.type : String(selectedItem.type);
                        if (selectedItem) {
                            itemsToSend.push({
                                id: selectedItem.id,
                                qty: selectedItem.quantity,
                                type: "product"
                            });
                        }
                        }
                        
                    }
        
                    // If there are items in the local cart, add them to the itemsToSend array
                    // if (cartItems.length > 0) {
                    //     cartItems.forEach(item => {
                    //         const existingItem = itemsToSend.find(i => i.id === item.product.id);
                    //         if (existingItem) {
                    //             existingItem.qty += item.qty;
                    //         } else {
                    //             itemsToSend.push({
                    //                 id: item.product.id,
                    //                 qty: item.qty,
                    //                 type: item.type
                    //             });
                    //         }
                    //     });
                    // }
        
                    if (itemsToSend.length === 0) {
                        $('.loader').fadeOut();
                        let infoMessage = document.createElement('div');
                        infoMessage.classList = 'info';
                        infoMessage.innerHTML = this.lang === 'ar' ? 'لم يتم تحديد أي عناصر للإضافة إلى السلة.' : 'No items selected to add to cart.';
                        document.getElementById('errors').append(infoMessage);
                        $('#errors').fadeIn('slow');
                        setTimeout(() => {
                            $('#errors').fadeOut('slow');
                        }, 2000);
                        return;
                    }
    
                    let data = {
                        items: itemsToSend,
                        platform: 'web'
                    };
        
                    const response = await axios.post(`${API_URL}/cart/add-multiple-items`, data,
                    {
                        headers: {
                            "lang": this.lang,
                            "AUTHORIZATION": "Bearer " + sessionStorage.getItem("user_token"),
                        }
                    }
                );
        
                    if (response.data.status === true) {
                        console.log("Cart update response:", response);
                        let successMessage = document.createElement('div');
                        successMessage.classList = 'success';
                        successMessage.innerHTML = response.data.message;
                        document.getElementById('errors').append(successMessage);
                        $('#errors').fadeIn('slow');
                        sessionStorage.removeItem('cartItems');
                        sessionStorage.removeItem('selectedItems'); // Clear selected items after successful server add
                        setTimeout(() => {
                            $('#errors').fadeOut('slow');
                            $('.loader').fadeOut();
                            window.location.href = '/my-cart';
                        }, 1500);
                    } else {
                        $('.loader').fadeOut();
                        if (response.data.errors) {
                            $.each(response.data.errors, function (key, value) {
                                let errorMessage = document.createElement('div');
                                errorMessage.classList = 'error';
                                errorMessage.innerHTML = value;
                                document.getElementById('errors').append(errorMessage);
                            });
                        } else if (response.data.message) {
                            let errorMessage = document.createElement('div');
                            errorMessage.classList = 'error';
                            errorMessage.innerHTML = response.data.message;
                            document.getElementById('errors').append(errorMessage);
                        } else {
                            let errorMessage = document.createElement('div');
                            errorMessage.classList = 'error';
                            errorMessage.innerHTML = this.lang === 'ar' ? 'فشل إضافة العناصر إلى السلة.' : 'Failed to add items to cart.';
                            document.getElementById('errors').append(errorMessage);
                        }
                        $('#errors').fadeIn('slow');
                        setTimeout(() => {
                            $('input').css('outline', 'none');
                            $('#errors').fadeOut('slow');
                        }, 3500);
                    }
        
                } catch (error) {
                    console.error("Error adding items to cart:", error);
                    let errorMessage = document.createElement('div');
                    errorMessage.classList = 'error';
                    errorMessage.innerHTML = this.lang === 'ar' ? 'خطأ أثناء إضافة العناصر إلى السلة.' : 'Error while adding items to cart.';
                    document.getElementById('errors').append(errorMessage);
                    $('#errors').fadeIn('slow');
                    $('.loader').fadeOut();
                    setTimeout(() => {
                        $('#errors').fadeOut('slow');
                    }, 3500);
                }
            }
        },
        async fetchProducts(categoryId) {
            $('.loader').fadeIn().css('display', 'flex')
            try {
                const response = await axios.get(`${API_URL}/products/category?category_id=${categoryId}&instock=true&per_page=${this.per_page}&page=${this.page}` + (this.sort_by_price ? `&sort_type=${this.sort_by_price}` : ''), {
                    headers: {
                        "AUTHORIZATION": 'Bearer ' + sessionStorage.getItem('user_token'),
                        "lang": this.lang
                    }
                });
                if (response.data.status === true) {
                    this.products = response.data.data.products
                    this.total = response.data.data.total
                    this.last_page = response.data.data.last_page
                    if (!this.products || !this.products[0])
                        this.showNotProducts = true
                    $('.loader').fadeOut()
                    setTimeout(() => {
                        $('#errors').fadeOut('slow')
                    }, 4000);
                } else {
                    $('.loader').fadeOut()
                    document.getElementById('errors').innerHTML = ''
                    $.each(response.data.errors, function (key, value) {
                        let error = document.createElement('div')
                        error.classList = 'error'
                        error.innerHTML = value
                        document.getElementById('errors').append(error)
                    });
                    $('#errors').fadeIn('slow')
                    setTimeout(() => {
                        $('input').css('outline', 'none')
                        $('#errors').fadeOut('slow')
                    }, 3500);
                }
            } catch (error) {
                document.getElementById('errors').innerHTML = ''
                let err = document.createElement('div')
                err.classList = 'error'
                err.innerHTML = 'server error try again later'
                document.getElementById('errors').append(err)
                $('#errors').fadeIn('slow')
                $('.loader').fadeOut()

                setTimeout(() => {
                    $('#errors').fadeOut('slow')
                }, 3500);
                console.error(error);
            }
        },
        toggleSelection(item) {
            if (!this.selectedItems) {
                this.selectedItems = {};
            }
            if (this.selectedItems[this.selectedCategoryId]?.id === item.id) {
                // Remove the selected item
                delete this.selectedItems[this.selectedCategoryId];
            } else {
                // Set selected item with default quantity
                console.log(item);
                this.selectedItems[this.selectedCategoryId] = { ...item, quantity: 1 };
                this.showDrawer = true;
            }
            // Save updated selectedItems to sessionStorage
            console.log(this.selectedItems, "selectedItems three");
            sessionStorage.setItem('selectedItems', JSON.stringify(this.selectedItems));
        },
        increaseQuantity(categoryId) {
            if (this.selectedItems[categoryId]) {
                const product = this.products.find(p => p.id === this.selectedItems[categoryId].id);
                if (product && this.selectedItems[categoryId].quantity < product.stock || product.type == 0) {
                    this.selectedItems[categoryId].quantity++;
                    sessionStorage.setItem('selectedItems', JSON.stringify(this.selectedItems));
                } else {
                    let errorMessage = this.lang === 'ar'
                        ? "لا يمكنك إضافة المزيد من هذا المنتج، الكمية غير متوفرة"
                        : "Cannot add more, stock is not available";
                    document.getElementById('errors').innerHTML = '';
                    let error = document.createElement('div');
                    error.classList = 'error';
                    error.innerHTML = errorMessage;
                    document.getElementById('errors').append(error);
                    $('#errors').fadeIn('slow');

                    setTimeout(() => {
                        $('#errors').fadeOut('slow');
                    }, 3000);
                }
            }
        },
        decreaseQuantity(categoryId) {
            if (this.selectedItems[categoryId] && this.selectedItems[categoryId].quantity > 1) {
                this.selectedItems[categoryId].quantity--;
                sessionStorage.setItem('selectedItems', JSON.stringify(this.selectedItems));
            }
        },
        removeSelectedItem(categoryId) {
            delete this.selectedItems[categoryId];
            sessionStorage.setItem('selectedItems', JSON.stringify(this.selectedItems));
        },
        setLangCookies() {
            let langCheck = document.cookie.indexOf('lang')

            this.is_cookies = langCheck >= 0 ? true : false

            function getCookie(cname) {
                let name = cname + "=";
                let decodedCookie = decodeURIComponent(document.cookie);
                let ca = decodedCookie.split(';');
                for (let i = 0; i < ca.length; i++) {
                    let c = ca[i];
                    while (c.charAt(0) == ' ') {
                        c = c.substring(1);
                    }
                    if (c.indexOf(name) == 0) {
                        return c.substring(name.length, c.length);
                    }
                }
                return "";
            } // to get an cookie by name ##############################

            if (langCheck !== -1) {
                this.lang = getCookie('lang') // check lang cookie exist ##############################
            }

            if (sessionStorage.getItem("lang"))
                this.lang = sessionStorage.getItem("lang") // check lang session exist ##############################

            sessionStorage.setItem("lang", this.lang); // set lang session ##############################

            let searchParams = new URLSearchParams(window.location.search)
            if (searchParams.has('lang')) {
                this.lang = searchParams.get('lang')
                document.body.classList.add(searchParams.get('lang')) // add lang class ##############################
            } else {
                document.body.classList.add(this.lang) // add lang class ##############################
            }

        },
        addProductToCompare(product) {
            $('.loader').fadeIn()
            if (localStorage.getItem('compare_cart')) {
                if (JSON.parse(localStorage.getItem('compare_cart')).length < 3) {
                    let compare = JSON.parse(localStorage.getItem('compare_cart'));
                    let itemExists1 = compare[0] ? compare[0].id == product.id : false
                    let itemExists2 = compare[1] ? compare[1].id == product.id : false
                    let itemExists3 = compare[2] ? compare[2].id == product.id : false
                    if (!itemExists1 && !itemExists2 && !itemExists3) {
                        compare.push(product)
                        localStorage.setItem('compare_cart', JSON.stringify(compare))
                        document.getElementById('errors').innerHTML = ''
                        let error = document.createElement('div')
                        error.classList = 'success'
                        error.innerHTML = this.lang == 'ar' ? 'تمت إضافة المنتج للمقارنة بنجاح' : 'product added to compare successfully'
                        document.getElementById('errors').append(error)
                        $('#errors').fadeIn('slow')
                        setTimeout(() => {
                            $('input').css('outline', 'none')
                            $('#errors').fadeOut('slow')
                            $('.loader').fadeOut()
                        }, 2000);
                    } else {
                        document.getElementById('errors').innerHTML = ''
                        let error = document.createElement('div')
                        error.classList = 'error'
                        error.innerHTML = this.lang == 'ar' ? 'هذا المنتج موجود بالفعل في المقارنة' : 'This product is already in the compare'
                        document.getElementById('errors').append(error)
                        $('#errors').fadeIn('slow')
                        $('input').css('outline', 'none')
                        $('#errors').fadeOut('slow')
                        $('.loader').fadeOut()
                    }
                } else {
                    document.getElementById('errors').innerHTML = ''
                    let error = document.createElement('div')
                    error.classList = 'error'
                    error.innerHTML = this.lang == 'ar' ? 'المقارنة لا يمكن أن تحتوي على أكثر من 3 عناصر' : 'Compare cannot have more than 3 items'
                    document.getElementById('errors').append(error)
                    $('#errors').fadeIn('slow')
                    setTimeout(() => {
                        $('input').css('outline', 'none')
                        $('#errors').fadeOut('slow')
                        $('.loader').fadeOut()
                    }, 2000);
                }
            } else {
                let compare = []
                compare.push(product)
                localStorage.setItem('compare_cart', JSON.stringify(compare))
                document.getElementById('errors').innerHTML = ''
                let error = document.createElement('div')
                error.classList = 'success'
                error.innerHTML = this.lang == 'ar' ? 'تمت إضافة المنتج للمقارنة بنجاح' : 'product added to compare successfully'
                document.getElementById('errors').append(error)
                $('#errors').fadeIn('slow')
                setTimeout(() => {
                    $('input').css('outline', 'none')
                    $('#errors').fadeOut('slow')
                    $('.loader').fadeOut()
                }, 2000);
            }
        },
        getHomeData() {
            this.setLangCookies()
            this.getCategories().then(() => {
                this.fetchProducts(this.selectedCategoryId);
                this.selectedItems = JSON.parse(sessionStorage.getItem('selectedItems')) || [];
            })
            console.log(JSON.parse(sessionStorage.getItem('cartItems')));
        },
    },
    created() {
        this.getHomeData()
    },
    mounted() {
        $(document).mousemove(function (e) {
            $('.hint-pop-up').css({
                top: e.clientY,
                left: e.pageX + 10 // Adjust the position to 10px to the right of the mouse
            });
        });
    },
}
</script>

<style scoped>
@import './../assets/css/home.css';
</style>
<style>
.hint-pop-up {
    position: fixed;
    display: none;
    padding: 10px;
    background-color: #f1f1f1;
    border: 1px solid #ccc;
    z-index: 99999;
    font-size: 12px;
    border-radius: 10px;
}

.prod-name:hover .hint-pop-up {
    display: block;
}

.prod-name {
    position: relative;
    cursor: pointer;
}

.responsive-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 10px;
}

.price-stock {
    display: flex;
    gap: 1rem;
    align-items: center;
    text-align: center;
    margin-left: auto;
}

.category-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    /* padding: 10px; */
}

.listtile {
    display: flex;
    align-items: center;
    justify-content: space-between;
    /* font-size: 12px; */
    width: 100%;
    padding: 5px;
    gap: 10px;
    position: relative;
}

.titleAndQuantity {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    /* Centers quantity horizontally */
    text-align: center;
    overflow: hidden;
}

.listtile i {
    margin-left: auto;
    color: red;
    cursor: pointer;
    font-size: 14px;
    flex-shrink: 0;
}

/* .listtile i {
    cursor: pointer;
    color: red;
    font-size: 14px;
} */

.productImage {
    width: 50px;
    height: 50px;
    background-color: #eee;
    border-radius: 2px;
    flex-shrink: 0;
    box-shadow: 0px 0px 15.5px rgba(211, 211, 211, 0.23);
}

.productImage img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 2px;
}


/* .titleAndQuantity {
    display: flex;
    flex-direction: column;
    justify-content: center;
} */

.prod-name.desc div {
    display: -webkit-box;
    /* -webkit-line-clamp: 2; */
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    max-height: 3em;
    white-space: normal;
}

.titleAndQuantity p {
    font-size: 14px;
    text-align: left;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
    /* max-width: 180px; */
}


.quantity {
    display: flex;
    justify-content: center;
    align-items: center !important;
    gap: 5px;
}

.qtyBtn {
    font-size: 20px !important;
    font-weight: 800 !important;
    cursor: pointer;
    text-align: center;
    font-weight: bold;
    justify-content: center;
    align-items: center;
}

.quantity span {
    font-size: 12px;
    min-width: 20px;
    text-align: center;
    font-weight: bold;
    justify-content: center;
    align-items: center;
}

button:disabled {
    cursor: not-allowed;
}

@media (max-width: 800px) {
    .responsive-container {
        flex-direction: column;
        align-items: flex-start;
        gap: 10px;
    }

    .price-stock {
        flex-direction: column;
        align-items: center;
        gap: 5px;
        margin-left: 0;
    }
}

.drawer-toggle-icon {
    position: fixed;
    top: 50%;
    right: 350px;
    /* When drawer is open */
    transform: translateY(-50%);
    background-color: #ffffff;
    border: 1px solid #ccc;
    border-right: none;
    border-radius: 10px 0 0 10px;
    padding: 8px 12px;
    z-index: 10000;
    cursor: pointer;
    transition: right 0.3s ease, background-color 0.3s ease;
}

.drawer-toggle-icon:hover {
    background-color: #e4e4e4;
}

.drawer-toggle-icon i {
    font-size: 18px;
    transition: transform 0.3s ease;
}

.side-drawer {
    position: fixed;
    top: 0;
    /* top: 58px;
  bottom: 58px; */
    right: 0;
    /* height: calc(100vh - 116px);  */
    height: 100vh;
    width: 0;
    background-color: #fff;
    overflow-x: hidden;
    overflow-y: auto;
    transition: width 0.3s ease;
    box-shadow: -2px 0 5px rgba(0, 0, 0, 0.1);
    z-index: 9999;
    display: flex;
}

.side-drawer.open {
    width: 350px;
}

.drawer-content {
    padding: 58px 20px 20px 20px;
    width: 100%;
}


.empty-msg {
    text-align: center;
    padding: 20px;
    font-style: italic;
    color: #888;
}

.selected-component {
    /* padding: 10px 0px 10px 0px; */
    padding-top: 10px;
}
</style>